var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventbriteListingsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9f7c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    stopColor: "#f4a675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ff5e30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99468,
    stopColor: "#c02a30"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.25297,
    y: 25.14138,
    width: 15.49399,
    height: 6.76922
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.62362,28.52597v5.26128h-19.24729v-5.26128h-8.70233v46.33265h36.65202V28.52597h-8.70239ZM56.16378,67.11122c-1.59127.22673-2.89595-.31974-4.04325-1.41705-3.70787-3.54637-7.44095-7.0664-11.15827-10.60286-1.1012-1.04765-1.47472-2.33762-1.0614-3.79229.40536-1.4265,1.38406-2.34323,2.83977-2.62769.73249-.14318,1.50439-.0851,2.25858-.11626.12588-.00521.25434.01271.37759-.00624.08854-.01363.17032-.0709.25514-.1087-.03963-.08602-.05721-.19781-.12267-.25371-.32558-.27816-.66411-.54115-.99737-.81038-.31367-.25337-.63181-.50158-.93849-.76319-.81187-.69246-1.0807-1.59207-.7562-2.50044.33635-.94153,1.19266-1.53875,2.24598-1.54327,1.63943-.00704,3.27892-.00189,4.9184-.00189,1.61429,0,3.22858-.00716,4.84275.00298.80929.0051,1.50943.27055,1.99124.96272.49957.71772.49184,1.73988-.01054,2.4533-.53101.75408-1.46487,1.13012-2.32496.86198-.69578-.21688-1.36556-.5171-2.0468-.78066-.09404-.03637-.18584-.09839-.2816-.10475-.09587-.00641-.19546.04209-.2934.06655.04839.08934.07394.21602.14896.26201.47237.28962.95579.56131,1.43555.83896,1.05756.61199,2.11901,1.21729,3.17153,1.83776,1.14181.67304,1.68439,1.89257,1.45445,3.22634-.20365,1.18098-1.22909,2.20412-2.47237,2.40657-.75299.12267-1.47432-.01632-2.14828-.40565-.93792-.54184-1.88644-1.06564-2.83896-1.58136-.12731-.06895-.30468-.04547-.45891-.06477.08642.13476.14444.30577.26345.39889,2.57042,2.01175,5.14113,4.02332,7.72661,6.01571,1.14902.8854,1.81697,2.03271,1.88174,3.46917.10801,2.39391-1.61727,4.35893-3.85827,4.67821Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventbriteListingsScraper);
export default __webpack_public_path__ + "static/media/eventbrite-listings-scraper.cbff3fc357fee47be1f8bac3f3b9781e.svg";
export { ForwardRef as ReactComponent };